import BaseModel from '../base/BaseModel.model';
export default class UserResearchCenter extends BaseModel {

  public userId?:number;
  public researchCenterId?:number;
  public isAdmin?: Boolean;
  public isCollaborator?: Boolean;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.userId = 0;
    this.researchCenterId = 0;
    this.isAdmin = false;
    this.isCollaborator = false;
  }
}